export type JcAuthProviderId = 'google.com' | 'password';

export type JcAuthErrorCode =
    | 'invalid-credentials'          // wrong password, or no such email
    | 'invalid-email'                // malformed email
    | 'weak-password'                // password too short / not accepted by Firebase
    | 'email-already-in-use'         // sign-up: email is already a password account
    | 'wrong-provider'               // email exists but under a different provider
    | 'popup-closed'                 // user closed the Google popup
    | 'too-many-requests'            // Firebase throttled the client
    | 'network'                      // offline / fetch failed
    | 'unknown';                     // catch-all

/**
 * Every expected auth failure from `JcAuthService`. `code` discriminates the
 * case so forms can render an inline message without inspecting Firebase codes.
 */
export class JcAuthError extends Error {
    readonly code: JcAuthErrorCode;
    /** On `wrong-provider`, the provider the email is already registered with. */
    readonly existingProvider?: JcAuthProviderId;

    constructor(code: JcAuthErrorCode, message: string, existingProvider?: JcAuthProviderId) {
        super(message);
        this.name = 'JcAuthError';
        this.code = code;
        this.existingProvider = existingProvider;
    }
}
